var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('recipe-info',{staticClass:"step-box"}),_c('div',{staticClass:"code-box"},[_c('img',{staticClass:"code",attrs:{"src":_vm.codeUrl}}),_c('h4',[_vm._v(_vm._s(_vm.$t('扫码修改菜谱')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }